export const playersSpawnLocations = [
    [3,6],[6,3],[12,3],[15,6],[12,12],[6,12]
    // [1,4],[4,1],[10,1],[13,4],[10,10],[4,10]
]